import { Outlet,ScrollRestoration } from "react-router-dom";

const Layout = () =>{
    return (
        <main className="App">
            <div>
            <Outlet/>
            </div>
          
        </main>
    )

}

export default Layout